import LogoChatSystem from "@/assets/svg/logo/logo.svg";

const Logo = () => {
  return (
    <>
      <div className="flex w-40">
        <div className="max-w-6 fillPrimaryColor">
          <LogoChatSystem />
        </div>
        <p
          style={{
            fontFamily:
              "SF Pro Display, SF Pro Icons, Helvetica Neue, Helvetica, Arial, sans-serif",
            fontSize: "22px",
            marginLeft: "10px",
          }}
        >
          <span className="font-bold">Chat</span>
          <span className="font-normal">System</span>
        </p>
      </div>
    </>
  );
};

export default Logo;
